var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetectPreviewArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1C3.44444 1 3 1.44444 3 2C3 2.55556 3.44444 3 4 3C4.55556 3 5 2.55556 5 2C5 1.44444 4.55556 1 4 1Z",
    fill: "#8E90A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2C4.5 1.72386 4.27614 1.5 4 1.5C3.72386 1.5 3.5 1.72386 3.5 2H4.5ZM3.64645 10.3536C3.84171 10.5488 4.15829 10.5488 4.35355 10.3536L7.53553 7.17157C7.7308 6.97631 7.7308 6.65973 7.53553 6.46447C7.34027 6.2692 7.02369 6.2692 6.82843 6.46447L4 9.29289L1.17157 6.46447C0.976311 6.2692 0.659728 6.2692 0.464466 6.46447C0.269204 6.65973 0.269204 6.97631 0.464466 7.17157L3.64645 10.3536ZM3.5 2C3.5 1.72059 3.72059 1.5 4 1.5V0.5C3.1683 0.5 2.5 1.1683 2.5 2H3.5ZM4 1.5C4.27941 1.5 4.5 1.72059 4.5 2H5.5C5.5 1.1683 4.8317 0.5 4 0.5V1.5ZM4.5 2C4.5 2.27941 4.27941 2.5 4 2.5V3.5C4.8317 3.5 5.5 2.8317 5.5 2H4.5ZM4 2.5C3.72059 2.5 3.5 2.27941 3.5 2H2.5C2.5 2.8317 3.1683 3.5 4 3.5V2.5ZM3.5 2V3H4.5V2H3.5ZM3.5 3V10H4.5V3H3.5Z",
    fill: "#8E90A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectPreviewArrow);
export default __webpack_public_path__ + "static/media/detectPreviewArrow.b4bcf90275d2f4fbce16cbe9235652eb.svg";
export { ForwardRef as ReactComponent };